import { render, staticRenderFns } from "./BSTable.vue?vue&type=template&id=2864b72d&"
import script from "./BSTable.vue?vue&type=script&lang=js&"
export * from "./BSTable.vue?vue&type=script&lang=js&"
import style0 from "./BSTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports